import React from "react";

import './App.css';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import Routes from "./Routes";

const App = () => {

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#007bff',
        contrastText: "#fff"
      },
      // secondary: {
      //   main: '#FDCC08',
      //   contrastText: "#333"
      // }
    },
    typography: {
      fontFamily: [
        'Monserrat',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif'
      ].join(','),
    }
  },
  )

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Routes />
      </div>
    </MuiThemeProvider>
  );
};

export default App;